import _ from 'lodash';

import Roles from '@/enums/Roles';
import GetAllRegionGroups from '@/services/GetAllRegionGroups';
import EPCGridView from '@/views/EPCGridView/EPCGridView';

import SearchUsersModalView from '../SearchUsersModalView/SearchUsersModalView';

const SearchEPCUsersModalView = SearchUsersModalView.extend({
  initialize() {
    this.options.searchFields = this.getSearchFields;
    this.options.gridView = EPCGridView;
  },

  getSearchFields() {
    return [
      {
        id: 'name-search-field',
        name: 'name',
        class: 'InputSearchField',
        placeholder: 'EPC Name'
      },
      {
        id: 'region-group-search-field',
        name: 'epcRegion',
        class: 'SelectSearchField',
        placeholder: 'Region Group',
        lookupService: GetAllRegionGroups,
        lookupMapping: (group) => {
          const { regionGroup, id } = group;
          return { optionText: regionGroup, id };
        }
      },
      {
        id: 'userType-search-field',
        hidden: true,
        value: Roles.EPC,
        name: 'userType',
        class: 'InputSearchField'
      }
    ];
  },

  getGridView() {
    return EPCGridView;
  },

  handleResponse(response) {
    _.each(response, (internalUser) => (internalUser.regionGroupName = internalUser.regionGroupNames));
  }
});

export default SearchEPCUsersModalView;
